import Container from '../../components/Theme/Auth';
import Input from '../../components/Input';
import Submit from '../../components/Button/Loading';
import Button from '@mui/material/Button';
import { NavLink } from 'react-router-dom';
const Login=()=>{
  return  <Container>
            <Input size="small" fullWidth name="email" type="email" label="Correo electrónico"/>
            <Submit fullWidth type="submit" label="Recuperar Contraseña"/>
            <Button to="/auth/register" component={NavLink}>Crear Cuenta</Button>
            <Button to="/auth" component={NavLink}>Iniciar sesión</Button>
          </Container>
}
export default Login
